import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Goals from '../../../../student/Register/Goal'

import { getStudentGoal } from '../../../../../routing/fetchingfunction/user/user.action'
import { selectStudentGoal } from '../../../../../routing/fetchingfunction/user/user.reducer'

const GoalsPreferences = () => {
  const dispatch = useDispatch()

  const studentGoal = useSelector(selectStudentGoal)

  useEffect(() => {
    dispatch(getStudentGoal())
  }, [dispatch])

  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Goals & Preferences Settings
      </h3>

      <div className="mt-[20px] rounded-[10px] w-full bg-[#FEEBDD] py-[64px] px-[148px] flex flex-col items-center justify-center">
        <Goals
          goal={studentGoal}
          submitText="Save"
          countryWrapperClassName="!min-w-[300px]"
          className="!p-0 !m-0"
          submitClassName="!w-[248px] h-[44px] mx-auto"
        />
      </div>
    </div>
  )
}

export default GoalsPreferences
